export const LettersRoutes = [
  {
    path: '/letterConfigs',
    name: 'letterConfigs',
    component: () => import('./views/LetterConfigsList.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['superadmin', 'admin'],
    },
  },
  {
    path: '/letterConfig/add',
    name: 'CreateLetterConfig',
    component: () => import('./views/CreateLetterConfig.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['superadmin', 'admin'],
    },
  },
  {
    path: '/letterConfig/detail/:id',
    name: 'LetterConfigDetail',
    component: () => import('./views/LetterConfigDetail.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['superadmin', 'admin'],
    },
  },
  {
    path: '/letterRequests',
    name: 'LetterRequests',
    component: () => import('./views/LetterRequests.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['employee', 'supervisor'],
    },
  },
  {
    path: '/letterRequests/:id',
    name: 'LetterRequestsdetail',
    component: () => import('./views/LetterRequestDetail.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['supervisor'],
    },
  },
  {
    path: '/letterRequests/approver',
    name: 'LetterRequestsApprover',
    component: () => import('./views/LetterRequestsApprover.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['supervisor'],
    },
  },
  {
    path: '/letterExternals/create',
    name: 'CreateExternalLetters',
    component: () => import('./views/external/CreateExternalLetters.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['superadmin', 'admin', 'RRHH'],
    },
  },
  {
    path: '/letterExternals/detail/:id',
    name: 'ExternalLetterDetail',
    component: () => import('./views/external/ExternalLettersDetail.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['superadmin', 'admin', 'RRHH'],
    },
  },
]
